import { FC } from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import css from 'classnames'
import { observer } from 'mobx-react-lite'
import { MenuModel } from '~/shared/lib'
import { useStore } from '~/app/store'
import { ExpressOrderIndicator } from '~/features/express-order-indicator'
import { useCurrentLegalEntityStores } from '~/shared/lib/hooks/use-current-legal-entity-stores'

interface Props {
  item: MenuModel
}

export const NavSub: FC<Props> = observer(({ item }) => {
  const { t } = useTranslation()
  const { warehousesStore } = useStore()
  const stores = useCurrentLegalEntityStores()

  return (
    <div className="p-0">
      <div className="absolute top-full min-w-[280px] z-[999] hidden group-hover:md:block hover:md:block">
        <div className="py-1" />
        <div className="bg-white rounded shadow-md z-50 overflow-hidden">
          <ul>
            {item?.subLinks?.map((link) => (
              <li
                className="text-sm group relative text-gray-600"
                key={link.name}
              >
                <NavLink
                  to={link.link}
                  className={({ isActive }) => {
                    return css(
                      'p-3 pl-0 flex hover:bg-slate-100 group justify-between items-center',
                      {
                        '[&>span]:flex': isActive,
                      },
                    )
                  }}
                >
                  <span className="w-[2px] h-5 rounded-md bg-blue-600 hidden absolute opacity-0 group-hover:opacity-100 left-0 transition-all" />
                  <span className="ml-3">
                    {link.link === '/stores' && stores.length === 1
                      ? t('settings')
                      : t(link.localeTextName)}
                  </span>
                  {link.badgeKey ? (
                    <span className="relative mr-3 min-w-[24px] h-[24px] px-2 rounded-full bg-white border border-gray-300 text-[11px] leading-none flex items-center justify-center text-[#242424]">
                      {warehousesStore.getStatusCount(link.badgeKey)}
                      {link.indicatorKey === 'express' ? (
                        <ExpressOrderIndicator
                          variant="dot"
                          className="absolute -right-0.5 -top-0.5"
                        />
                      ) : null}
                    </span>
                  ) : null}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
})
